import { render, staticRenderFns } from "./TheTopazio.vue?vue&type=template&id=52678caf&"
import script from "./TheTopazio.vue?vue&type=script&lang=js&"
export * from "./TheTopazio.vue?vue&type=script&lang=js&"
import style0 from "./TheTopazio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports